import React from 'react';
import classnames from 'classnames';
import styles from "../../admin/styles.module.scss";
import { MdDelete, MdEdit } from 'react-icons/md';
import { TooltipTop } from '@components/tooltips';
import { EyeIcon } from '@pages/workflow-analytics-page/assets/icons';
import { useSelector } from 'react-redux';
import { RootState } from '@store/types';
import { errorAlert } from '@components/toastify/notify-toast';
import { useAppSelector } from '@store/hooks';
import { ProjectData } from './types';


type ProjectListProps = {
  data: ProjectData[] | null;
  handleDelete: (item: ProjectData) => void;
  handleEdit: (item: ProjectData) => void;
  handleViewClassdata: (item: ProjectData) => void;
};

const ProjectList: React.FC<ProjectListProps> = ({ data, handleDelete, handleEdit, handleViewClassdata }) => {
  const { envVariables: Env } = useSelector((store: RootState) => store.AccountReducer);
  const currentUser = useAppSelector((state) => state.AccountReducer.activeUserInfo.email);
  
  return (
    <div className={styles["assetHierarchyList"]}>
      <ul className={classnames(styles['nifi_titles'])} style={{  maxHeight: "48vh"}}>
        {data?.map((item, index) => (
          <li className={classnames(styles['project_titles'])} key={index}>
            <div>
              <div className={styles['key']}>Class Name</div>
              <TooltipTop title={item.name}>
                <div className={styles['hierarchyName']}>{item.name}</div>
              </TooltipTop>
            </div>
            <div>
              <div className={styles['key']}>Super Class</div>
              <TooltipTop title={item.superclass}>
                <div className={styles['hierarchyName']}>{item.superclass}</div>
              </TooltipTop>
            </div>
            <div className={styles['divider']}></div>
            
            <div className={styles.actions}>
              <TooltipTop title="Edit Class">
                <button className={styles.actionButton} onClick={() => handleEdit(item)}>
                  <div className={styles.center}><MdEdit size={"24px"} /></div>
                </button>
              </TooltipTop>
              {/* <TooltipTop title="View Class">
                <button className={styles.actionButton} onClick={() => handleViewClassdata(item)}>
                  <div className={styles['center']}><EyeIcon /></div>
                </button>
              </TooltipTop> */}
              <TooltipTop title="Delete Class">
                <button
                  className={styles.deleteButton}
                  onClick={() => handleDelete(item)}
                >
                  <div className={styles.actionButton}><MdDelete size={"24px"} /></div>
                </button>
              </TooltipTop>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ProjectList;
